import type { UniverseGeneralInformation } from '../../../domain/UniverseGeneralInformation'
import type { UniverseGeneralInformationDTO } from '../../../domain/UniverseGeneralInformationDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'

import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

export const mapUniverseGeneralInformationFromApi = (
  dto: UniverseGeneralInformationDTO,
): UniverseGeneralInformation | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { anchorColor, backgroundImage, description, level, logo, name, slug, themeColor } = dto.fields

  return {
    anchorColor,
    backgroundImage: backgroundImage?.fields,
    contentType: ContentModelId.UNIVERSE_GENERAL_INFORMATION,
    description,
    level,
    logo: logo?.fields,
    name,
    slug,
    themeColor,
  }
}
